import { CustomCalendarTemplateType } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { organiserCalendarTemplatesQueryKeys } from "../query-keys";

const getMyOrganiserCalendarTemplates = async (): Promise<CustomCalendarTemplateType[]> => {
  const { data } = await privateAxios.get<CustomCalendarTemplateType[]>(
    `/custom-calendar/template`
  );
  return data ?? [];
};

export const useGetMyOrganiserCalendarTemplatesQuery = () => {
  return useQuery({
    queryKey: organiserCalendarTemplatesQueryKeys.all,
    queryFn: getMyOrganiserCalendarTemplates,
  });
};
